export default "__VITE_ASSET__b785d91e__"